module.exports = __webpack_public_path__ + "img/EditIconGreen.f4a3bf41.svg";